var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeaListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.008 0C23.28 0 24.504 0.504 25.416 1.416L36.984 13.008C37.896 13.896 38.4 15.12 38.4 16.392V43.2C38.4 45.84 36.24 48 33.6 48H4.776C2.136 48 0 45.84 0 43.2V4.8C0 2.16 2.16 0 4.8 0H22.008ZM21.6 3.6V14.4C21.6 15.72 22.68 16.8 24 16.8H34.8L21.6 3.6ZM17.28 41.2799C17.28 42.3359 18.144 43.1999 19.2 43.1999C20.256 43.1999 21.12 42.3359 21.12 41.2799H17.28ZM22.08 40.32H16.32C15.792 40.32 15.36 39.888 15.36 39.36C15.36 38.832 15.792 38.4 16.32 38.4H22.08C22.608 38.4 23.04 38.832 23.04 39.36C23.04 39.888 22.608 40.32 22.08 40.32ZM26.4 31.2C26.4 27.2256 23.1744 24 19.2 24C15.2256 24 12 27.2256 12 31.2C12 34.8672 14.5536 36.8256 15.6192 37.44H22.7808C23.8464 36.8256 26.4 34.8672 26.4 31.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaListIcon);
export default __webpack_public_path__ + "static/media/ideaListIcon.590b8c74.svg";
export { ForwardRef as ReactComponent };